import { DateTimeBox, DateTimeBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../state/standardLoanStore';
import { isNoteDateRequired } from '../functions/isNoteDateRequired';

/** Changing the Note Date recalculates the Maturity Date (Note Date + Initial Term). */
export const NoteDateField = () => {
    const value = useStandardLoanStore((state) => state.setup.noteDate);
    const context = useStandardLoanStore((state) => state.setupLoanContext);
    const updateSetup = useStandardLoanStore((state) => state.updateSetup);

    return (
        <DateTimeBox
            id='setupNoteDate'
            value={value}
            onChange={(noteDate) => updateSetup({ noteDate })}
            // DateTimeBox doesn't call onChange when the date is cleared (or an invalid date is rejected); it only
            // fails validation. Treat a failed validation as "no date".
            onValidationEvent={(isValid) => {
                if (!isValid) {
                    updateSetup({ noteDate: undefined });
                }
            }}
            label='Note Date'
            required={isNoteDateRequired(context)}
            width='160px'
            placeholder='MM/DD/YYYY'
            height='36px'
            layoutStyle={DateTimeBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
